import { IconAlertTriangleFillSmall } from '@amzn/stencil-react-icons';

/**
 * The site-wide critical "warning triangle" glyph: {@link IconAlertTriangleFillSmall}
 * at the critical-icon color. Centralizes the icon + color pairing so every
 * feature flags a problem with the same marker (audit-insights failure themes,
 * the AuditWhiz incomplete-sub marker, etc.) instead of each spelling out the
 * icon and color.
 *
 * Stencil icons are decorative (rendered `aria-hidden`, and they drop
 * `aria-label`), so this carries NO accessible name of its own. When the marker
 * conveys meaning, the CALLER must supply the accessible name on a wrapping
 * element (e.g. a `role="img"` container with `aria-label`).
 */
export function AlertTriangleFillIcon(): JSX.Element {
  return <IconAlertTriangleFillSmall color="color.status.critical-icon" />;
}
